import { CalendarDate, getLocalTimeZone } from '@internationalized/date';
import { format } from 'date-fns';
import qs from 'qs';

/**
 * Parse a URL search string into a plain object (shared qs policy for list queries).
 */
export function parseQuerySearch(search: string): Record<string, unknown> {
  return qs.parse(search, {
    allowDots: true,
    plainObjects: true,
    ignoreQueryPrefix: true,
    allowEmptyArrays: true
  }) as Record<string, unknown>;
}

/**
 * Stringify query params for list URLs (shared qs policy + date filters).
 */
export function stringifyQueryParams(params: object): string {
  return qs.stringify(params, {
    allowDots: true,
    encode: true,
    allowEmptyArrays: true,
    filter: (_prefix, value) => {
      if (value === undefined) {
        return null;
      }
      if (value instanceof Date) {
        return format(value, 'yyyy-MM-dd');
      }
      if (value instanceof CalendarDate) {
        return format(value.toDate(getLocalTimeZone()), 'yyyy-MM-dd');
      }
      return value;
    }
  });
}
